import MakePayment from './MakePayment';
import { SELECTORS } from './utils/constants';

document.addEventListener('DOMContentLoaded', async () => {
  console.log('custom code loaded');
  const quoteForm = document.querySelector(SELECTORS.quoteForm) as HTMLFormElement;
  const policyForm = document.querySelector(SELECTORS.policyForm) as HTMLFormElement;
  new MakePayment(quoteForm);
  new MakePayment(policyForm);
});
